import { memo } from 'react';
import Script from 'next/script';
import { CustomAppEvents } from 'core/common/entities';
import { areArraysOfPrimitivesEqual } from 'core/common/utils/areArraysOfPrimitivesEqual';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { AnalyticsPixelId } from '../../entities';
import { BingAdsScriptsService } from '../../services';

type BingAdsScriptsProps = {
  ids: Array<AnalyticsPixelId>;
};

const BingAdsScripts = (props: BingAdsScriptsProps) => {
  return (
    <>
      {props.ids.map((id: string) => {
        return (
          <Script
            id={`bing-ads-${id}`}
            key={`bing-ads-${id}`}
            strategy="afterInteractive"
            onReady={() => {
              try {
                const event = new Event(CustomAppEvents.BING_ADS_LOADED);
                document.dispatchEvent(event);
              } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error dispatching Bing Ads loaded event', error);
              }
            }}
            dangerouslySetInnerHTML={prepareHtml(BingAdsScriptsService.getScriptCode(id))}
          />
        );
      })}
    </>
  );
};

export default memo(BingAdsScripts, (prevProps, nextProps) =>
  areArraysOfPrimitivesEqual(prevProps.ids, nextProps.ids),
);
